import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {

  }

  init(){
    this.matIconRegistry.addSvgIcon(
      'check',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/check.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'cross',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/cross.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'google',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/google-icon.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'dna-icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/dna-icon.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'world-wide',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/world-wide.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'i-icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/info_light.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'cross',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/cross.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'notification-pay',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/notification-pay.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'expand-up',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/expand-up.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'notification-error',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/notification-error.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'notification-refund',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/notification-refund.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'notification-renew',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/notification-renew.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'circle-left',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/circle_left.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'logout',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/logout.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'paw',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/paw.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'paper-light',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/paper-light.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'user-outline',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/user-outline.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'eye',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/eye-icon.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'file_dock',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/file_dock.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'shield_check',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/shield_check.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'user_duotone_line',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/user_duotone_line.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'copy',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/copy_alt.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'expand-up-double',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/expand-up-double-light.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'notification-voucher',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/gift_light.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'user-profile',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/user-profile.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'stethoscope',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/stethoscope.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'camera-light',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/camera-light.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'qr',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/qr.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'comment',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/comment.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'notification-info',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/info_light.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'download-light',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/download-light.svg')
    );
  }
}
